<template>
    <v-container class="pt-6">
      <v-btn @click="$router.go(-1)" text class="pl-0 mb-2 mx-4">
        <v-icon class="mr-2" size="15px"> mdi-arrow-left </v-icon>
        <span class="text-return mon-regular" style="font-family: 'montserrat-medium';">{{ "Regresar" }}</span>
      </v-btn>
      <v-card class="pa-6" outlined style="max-width: 800px; margin: auto;">
        <!-- Encabezado -->

        <!-- Detalle de la factura -->
        <div>
          <div class="mb-3 mt-3" style="display: flex; justify-content: space-between; align-items: center;">
            <div style="font-family: 'montserrat-bold'; font-size: 24px; width: fit-content;">
              Detalle de la factura
              <v-chip class="ml-4" color="blue" dark small label style="text-transform: capitalize;">
                {{ factura.estatus }}
              </v-chip>
            </div>
            
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn :disabled="false" @click="openUpdateInvoice()" v-bind="attrs" v-on="on" icon color="black">
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>{{ "Editar factura" }}</span> 
            </v-tooltip>
          </div>
          <v-row class="my-4">
            <v-col cols="6">
              <strong>PO:</strong>
              <div>{{ factura.external_invoice_id }}</div>
            </v-col>
            <v-col cols="6">
              <strong>Referencia:</strong>
              <div>{{ factura.reference }}</div>
            </v-col>
          </v-row>
          <v-row class="my-4">
            <v-col cols="6">
              <strong>Cedente:</strong>
              <div>{{ factura.cedente_name }}</div>
            </v-col>
            <v-col cols="6">
              <strong>Deudor:</strong>
              <div>{{ factura.deudor_name }}</div>
            </v-col>
          </v-row>
          <v-row class="my-4">
            <v-col cols="6">
              <strong>Monto:</strong>
              <div>${{ formatMoney(factura.monto_total) }} USD</div>
            </v-col>
            <v-col cols="6" style="display: flex; justify-content: space-between; align-items: center;">
              <div style="width: fit-content;">
                <strong>Ajuste:</strong>
                <div>${{ formatMoney(factura.ajuste) }} USD</div>
              </div>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn :disabled="false" @click="openCreateAdjust()" v-bind="attrs" v-on="on" icon color="black">
                    <v-icon v-if="factura.ajuste == 0">mdi-plus</v-icon>
                    <v-icon v-else>mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>{{ factura.ajuste == 0 ? "Agregar ajuste" : "Editar ajuste" }}</span> 
              </v-tooltip>
            </v-col>
          </v-row>
          <v-row class="my-4">
            <v-col cols="6">
              <strong>Fecha de emisión:</strong>
              <div>{{ formatDate(factura.fecha_emision) }}</div>
            </v-col>
            <v-col cols="6">
              <strong>Fecha de vencimiento:</strong>
              <div>{{ formatDate(factura.fecha_vencimiento) }}</div>
            </v-col>
          </v-row>
        </div>

        <!-- Resumen financiero -->
        <div>
          <v-divider class="my-4"></v-divider>
          <div class="mb-2" style="font-family: 'montserrat-bold'; font-size: 16px;">Resumen financiero</div>
          <div class="mb-4" style="background-color: #f1f6fb; padding: 16px; border-radius: 12px; box-shadow: 0 2px 4px rgba(0, 0, 0, 0.4);">
            <div style="font-family: 'montserrat-bold'; font-size: 14px;">
              Total de la factura: <strong>${{ formatMoney(factura.monto_total) }} USD</strong>
            </div>

            <v-divider class="my-3" />

            <div style="font-family: 'montserrat-medium'; font-size: 14px;">
              Pago del deudor:
              <strong style="color: green;">+${{ formatMoney(factura.pagosDeudor?.[0]?.amount || 0) }} USD</strong>
            </div>

            <div style="font-family: 'montserrat-medium'; font-size: 14px;">
              Adelanto:
              <strong>-${{ formatMoney(factura.adelantos?.[0]?.amount_applied || 0) }} USD</strong>
            </div>

            <div style="font-family: 'montserrat-medium'; font-size: 14px;">
              Interés moratorio:
              <strong>
                -${{
                  (factura.dias_moratorios > 0
                    ? (factura.monto_total * (factura.dias_moratorios / 30 * 0.025)).toFixed(2)
                    : "0.00")
                }} USD ({{ Math.max(0, factura.dias_moratorios || 0) }} días)
              </strong>
            </div>

            <div style="font-family: 'montserrat-medium'; font-size: 14px;">
              Comisión ({{ factura.tasa_interes }}%): <strong>-${{ formatMoney((factura.monto_total || 0) * (factura.tasa_interes / 100)) }} USD</strong>
            </div>

            <v-divider class="my-3" />

            <div style="font-family: 'montserrat-bold'; font-size: 16px;">
              Monto sugerido a liquidar: <strong>${{ formatMoney(montoSugerido) }} USD</strong>
            </div>
            <div style="font-family: 'montserrat-bold'; font-size: 16px; margin-top: 4px;">
              Monto liquidado: 
              <strong style="color: #0075B8;">
                ${{ formatMoney(factura.liquidaciones?.[0]?.amount || 0) }} USD
              </strong>
            </div>

            <div
              :style="{
                fontFamily: 'montserrat-bold',
                fontSize: '14px',
                marginTop: '4px',
                color: Math.abs((factura.liquidaciones?.[0]?.amount || 0) - montoSugerido) < 0.01 ? 'green' : 'red'
              }"
            >
              Diferencia:
              <strong>
                ${{ formatMoney(((factura.liquidaciones?.[0]?.amount || 0) - montoSugerido)) }} USD
              </strong>
            </div>
            <v-divider class="my-3" />

            <!-- Si hay diferencia positiva y compensaciones, muestra desglose -->
            <div v-if="diferenciaFinal < 0 && totalCompensado > 0" style="margin-top: 12px;">
              <div style="font-family: 'montserrat-bold'; font-size: 14px;">Detalle de compensación</div>

              <div style="font-family: 'montserrat-medium'; font-size: 14px;">
                A deber:
                <strong style="color: red;">
                  ${{ formatMoney(diferenciaFinal) }} USD
                </strong>
              </div>

              <div style="font-family: 'montserrat-medium'; font-size: 14px;">
                Compensado:
                <strong style="color: #0075B8;">
                  ${{ formatMoney(totalCompensado) }} USD
                </strong>
              </div>

              <div style="font-family: 'montserrat-medium'; font-size: 14px;">
                Diferencia:
                <strong :style="{ color: Math.abs(diferenciaFinal + totalCompensado) < 0.01 ? 'green' : 'red' }">
                  ${{ formatMoney(diferenciaFinal + totalCompensado) }} USD
                </strong>
              </div>
            </div>
          </div>
        </div>

        <!-- Documentos -->
        <div>
          <v-divider class="my-4"></v-divider>
          <div class="mb-2" style="font-family: 'montserrat-bold'; font-size: 16px;">Documentos adjuntos</div>
          <v-row dense>
            <v-col v-for="(doc, index) in factura.documentos || []" :key="index" cols="12" sm="6" md="4">
              <v-card class="pa-3 d-flex align-center justify-space-between" outlined>
                <div class="d-flex flex-column">
                  <span style="font-weight: 600;">{{ doc.file_name }}</span>
                  <span class="text--secondary text-caption">
                    {{ doc.size ? (doc.size / 1024).toFixed(1) + ' KB' : 'Documento subido' }}
                  </span>
                </div>
                <v-btn icon @click="abrirDocumento(doc)" target="_blank">
                  <v-icon color="primary">mdi-eye</v-icon>
                </v-btn>
              </v-card>
            </v-col>
            <v-col v-if="!factura.documentos || !factura.documentos.length">
              <div class="grey--text">No hay documentos adjuntos</div>
            </v-col>
          </v-row>
        </div>

        <!-- Adelantos -->
        <div>
          <v-divider class="my-4"></v-divider>
          <div class="mb-3 mt-3" style="display: flex; justify-content: space-between; align-items: center;">
            <div style="font-family: 'montserrat-bold'; font-size: 16px; width: fit-content;">
              Pagos realizados al cedente
            </div>
            
          </div>
          <v-list dense>
            <v-list-item v-for="adelanto in factura.adelantos || []" :key="adelanto.id">
              <v-list-item-content>
                <v-list-item-title>
                  {{ formatDate(adelanto.date_paid) }} - ${{ formatMoney(adelanto.amount_applied) }} USD
                </v-list-item-title>
                <v-list-item-subtitle v-if="adelanto.file_url">
                  <a @click="abrirComprobante(adelanto.file_url)" target="_blank" style="color: #0075B8;">Ver comprobante</a>
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn @click="openUpdateAdelanto(adelanto)" v-bind="attrs" v-on="on" icon color="black">
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>{{ "Editar adelanto" }}</span> 
              </v-tooltip>
            </v-list-item>
            <v-row dense>
              <v-col v-if="factura?.adelantos?.length === 0">
                <div class="grey--text">No hay adelantos realizados</div>
              </v-col>
            </v-row>
          </v-list>
        </div>

        <!-- Pagos del deudor -->
        <div>
          <v-divider class="my-4"></v-divider>
          <div class="mb-3 mt-3" style="display: flex; justify-content: space-between; align-items: center;">
            <div style="font-family: 'montserrat-bold'; font-size: 16px; width: fit-content;">
              Pagos del deudor
            </div>
          </div>
          <v-list dense>
            <v-list-item v-for="pago in factura.pagosDeudor || []" :key="pago.id">
              <v-list-item-content>
                <v-list-item-title>
                  {{ formatDate(pago.date_paid) }} - ${{ formatMoney(pago.amount) }} USD - Origen: {{ pago.origin }}
                </v-list-item-title>
                <v-list-item-subtitle v-if="pago.file_url">
                  <a @click="abrirComprobante(pago.file_url)" target="_blank" style="color: #0075B8;">Ver comprobante</a>
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn :disabled="false" @click="openUpdateCobro(pago)" v-bind="attrs" v-on="on" icon color="black">
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>{{ "Editar pago del deudor" }}</span> 
              </v-tooltip>
            </v-list-item>
            <v-row dense>
              <v-col v-if="factura?.pagosDeudor?.length === 0">
                <div class="grey--text">No hay cobros realizados</div>
              </v-col>
            </v-row>
          </v-list>
        </div>

      </v-card>

      <!-- Dialogo para actualizar factura -->
      <v-dialog v-model="dialogUpdateInvoice" max-width="650px">
        <v-card style="border-radius: 20px; padding: 24px;">
          <v-form ref="formNew" lazy-validation v-on:submit.prevent>
            <!-- Título -->
            <div style="font-family: 'montserrat-bold'; font-size: 22px; text-align: center;">
              Modificar Factura
            </div>
            <v-divider class="my-4" />
            <!-- Información básica -->
            <v-row dense>
              <v-col cols="6">
                <v-text-field
                  v-model="updateInvoice.po"
                  label="PO del Deudor"
                  outlined
                  style="border-radius: 10px;"
                  dense
                  class="mb-2"
                  hide-details
                  :rules="[rules.required]"
                  required
                />
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="updateInvoice.referencia"
                  label="Referencia interna (opcional)"
                  style="border-radius: 10px;"
                  outlined
                  class="mb-2"
                  hide-details
                  dense
                />
              </v-col>
            </v-row>
            <v-divider class="my-4" />
            <v-row dense>
              <v-col cols="6">
                <v-menu
                  ref="menuEmision"
                  v-model="menuEmision"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="updateInvoice.fechaEmision"
                      label="Fecha de Emisión"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      :rules="[rules.required]"
                      style="border-radius: 10px;"
                      class="mb-2"
                      outlined
                      hide-details
                      dense
                    />
                  </template>
                  <v-date-picker v-model="updateInvoice.fechaEmision" @input="menuEmision = false" />
                </v-menu>
              </v-col>
              <v-col cols="6">
                <v-menu
                  ref="menuVencimiento"
                  v-model="menuVencimiento"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="updateInvoice.fechaVencimiento"
                      label="Fecha de Vencimiento"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      style="border-radius: 10px;"
                      outlined
                      :rules="[rules.required]"
                      hide-details
                      class="mb-2"
                      dense
                    />
                  </template>
                  <v-date-picker v-model="updateInvoice.fechaVencimiento" @input="menuVencimiento = false" />
                </v-menu>
              </v-col>
            </v-row>

            <!-- Monto y Fechas -->
            <v-row dense style="align-items: center;">
              <v-col cols="6">
                <v-text-field
                  v-model.number="updateInvoice.monto"
                  label="Monto total (USD)"
                  type="number"
                  outlined
                  :rules="[rules.required]"
                  dense
                  hide-details
                  style="border-radius: 10px;"
                  required
                />
              </v-col>
              <v-col cols="6">
                <v-card
                  flat
                  class="d-flex align-center justify-center flex-column py-2"
                  style="background-color: #f6f6f6; border-radius: 12px; height: 100%; "
                >
                  <div class="mb-1" style="font-family: 'montserrat-bold'; font-size: 14px; color: #333;">
                    Monto total (USD)
                  </div>
                  <div style="font-family: 'montserrat-bold'; font-size: 20px; color: #333;">
                    ${{ formatMoney(updateInvoice.monto) }} USD
                  </div>
                </v-card>
              </v-col>
            </v-row>

            <v-divider class="my-4" />

            <!-- Acciones -->
            <v-card-actions>
              <v-btn 
                block
                large
                color="black"
                :disabled="!updateInvoice.po || !updateInvoice.fechaEmision || !updateInvoice.fechaVencimiento || updateInvoice.monto <= 0 || loadingUpdateInvoice"
                class="white--text mt-2"
                style="border-radius: 10px; text-transform: none; font-weight: 600;" 
                @click="saveUpdateInvoice()"
              >
                Guardar
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogCreateAdjust" max-width="650px">
        <v-card style="border-radius: 20px; padding: 24px;">
          <v-form ref="formNew" lazy-validation v-on:submit.prevent>
            <!-- Título -->
            <div style="font-family: 'montserrat-bold'; font-size: 22px; text-align: center;">
              {{ factura.ajuste == 0 ? "Agregar ajuste" : "Editar ajuste" }}
            </div>
            <v-divider class="my-4" />
            <!-- Monto y Fechas -->
            <v-row dense style="align-items: center;">
              <v-col cols="6">
                <v-text-field
                  v-model.number="updateInvoice.ajuste"
                  label="Monto total del ajuste (USD)"
                  type="number"
                  outlined
                  :rules="[rules.required]"
                  dense
                  hide-details
                  style="border-radius: 10px;"
                  required
                />
              </v-col>
              <v-col cols="6">
                <v-card
                  flat
                  class="d-flex align-center justify-center flex-column py-2"
                  style="background-color: #f6f6f6; border-radius: 12px; height: 100%; "
                >
                  <div class="mb-1" style="font-family: 'montserrat-bold'; font-size: 14px; color: #333;">
                    Monto total (USD)
                  </div>
                  <div style="font-family: 'montserrat-bold'; font-size: 20px; color: #333;">
                    ${{ formatMoney(updateInvoice.ajuste) }} USD
                  </div>
                </v-card>
              </v-col>
            </v-row>

            <v-divider class="my-4" />

            <!-- Acciones -->
            <v-card-actions>
              <v-btn 
                block
                large
                color="black"
                :disabled="updateInvoice.ajuste < 0 || updateInvoice.ajuste > factura.monto_total"
                class="white--text mt-2"
                style="border-radius: 10px; text-transform: none; font-weight: 600;" 
                @click="addAdjustment()"
              >
                Guardar
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogUpdateAdelanto" max-width="650px">
        <v-card style="border-radius: 20px; padding: 24px;">
          <v-form ref="formNew" lazy-validation v-on:submit.prevent>
            <!-- Título -->
            <div style="font-family: 'montserrat-bold'; font-size: 22px; text-align: center;">
              {{ "Modificar Adelanto" }}
            </div>
            <v-divider class="my-4" />
            <!-- Monto y Fechas -->
            <v-row dense style="align-items: center;">
              <v-col cols="6">
                <v-text-field
                  v-model.number="updateAdelanto.monto"
                  label="Monto total del ajuste (USD)"
                  type="number"
                  outlined
                  :rules="[rules.required]"
                  dense
                  hide-details
                  style="border-radius: 10px;"
                  required
                />
              </v-col>
              <v-col cols="6">
                <v-card
                  flat
                  class="d-flex align-center justify-center flex-column py-2"
                  style="background-color: #f6f6f6; border-radius: 12px; height: 100%; "
                >
                  <div class="mb-1" style="font-family: 'montserrat-bold'; font-size: 14px; color: #333;">
                    Monto total (USD)
                  </div>
                  <div style="font-family: 'montserrat-bold'; font-size: 20px; color: #333;">
                    ${{ formatMoney(updateAdelanto.monto) }} USD
                  </div>
                </v-card>
              </v-col>
            </v-row>

            <v-divider class="my-4" />
            <v-row dense>
              <v-col cols="12">
                <v-menu
                  ref="menuEmision"
                  v-model="menuEmision"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="updateAdelanto.fechaAdelanto"
                      label="Fecha de adelanto"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      :rules="[rules.required]"
                      style="border-radius: 10px;"
                      class="mb-2"
                      outlined
                      hide-details
                      dense
                    />
                  </template>
                  <v-date-picker color="black" v-model="updateAdelanto.fechaAdelanto" @input="menuEmision = false" />
                </v-menu>
              </v-col>
            </v-row>
            <!-- Acciones -->
            <v-card-actions>
              <v-btn 
                block
                large
                color="black"
                class="white--text mt-2"
                style="border-radius: 10px; text-transform: none; font-weight: 600;" 
                @click="updatePaymentAdelanto()"
              >
                Guardar
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogUpdateCobro" max-width="650px">
        <v-card style="border-radius: 20px; padding: 24px;">
          <v-form ref="formNew" lazy-validation v-on:submit.prevent>
            <!-- Título -->
            <div style="font-family: 'montserrat-bold'; font-size: 22px; text-align: center;">
              {{ "Modificar Adelanto" }}
            </div>
            <v-divider class="my-4" />
            <!-- Monto y Fechas -->
            <v-row dense style="align-items: center;">
              <v-col cols="6">
                <v-text-field
                  v-model.number="updateCobro.monto"
                  label="Monto total del ajuste (USD)"
                  type="number"
                  outlined
                  :rules="[rules.required]"
                  dense
                  hide-details
                  style="border-radius: 10px;"
                  required
                />
              </v-col>
              <v-col cols="6">
                <v-card
                  flat
                  class="d-flex align-center justify-center flex-column py-2"
                  style="background-color: #f6f6f6; border-radius: 12px; height: 100%; "
                >
                  <div class="mb-1" style="font-family: 'montserrat-bold'; font-size: 14px; color: #333;">
                    Monto total (USD)
                  </div>
                  <div style="font-family: 'montserrat-bold'; font-size: 20px; color: #333;">
                    ${{ formatMoney(updateCobro.monto) }} USD
                  </div>
                </v-card>
              </v-col>
            </v-row>

            <v-divider class="my-4" />
            <v-row dense>
              <v-col cols="12">
                <v-menu
                  ref="menuEmisionCobro"
                  v-model="menuEmisionCobro"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="updateCobro.fechaCobro"
                      label="Fecha de cobro"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      :rules="[rules.required]"
                      style="border-radius: 10px;"
                      class="mb-2"
                      outlined
                      hide-details
                      dense
                    />
                  </template>
                  <v-date-picker color="black" v-model="updateCobro.fechaCobro" @input="menuEmisionCobro = false" />
                </v-menu>
              </v-col>
            </v-row>
            <!-- Acciones -->
            <v-card-actions>
              <v-btn 
                block
                large
                color="black"
                class="white--text mt-2"
                style="border-radius: 10px; text-transform: none; font-weight: 600;" 
                @click="updatePaymentCobro()"
              >
                Guardar
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogUpdateLiquidacion" max-width="650px">
        <v-card style="border-radius: 20px; padding: 24px;">
          <v-form ref="formNew" lazy-validation v-on:submit.prevent>
            <!-- Título -->
            <div style="font-family: 'montserrat-bold'; font-size: 22px; text-align: center;">
              {{ "Modificar Adelanto" }}
            </div>
            <v-divider class="my-4" />
            <!-- Monto y Fechas -->
            <v-row dense style="align-items: center;">
              <v-col cols="6">
                <v-text-field
                  v-model.number="updateLiquidacion.monto"
                  label="Monto total del ajuste (USD)"
                  type="number"
                  outlined
                  :rules="[rules.required]"
                  dense
                  hide-details
                  style="border-radius: 10px;"
                  required
                />
              </v-col>
              <v-col cols="6">
                <v-card
                  flat
                  class="d-flex align-center justify-center flex-column py-2"
                  style="background-color: #f6f6f6; border-radius: 12px; height: 100%; "
                >
                  <div class="mb-1" style="font-family: 'montserrat-bold'; font-size: 14px; color: #333;">
                    Monto total (USD)
                  </div>
                  <div style="font-family: 'montserrat-bold'; font-size: 20px; color: #333;">
                    ${{ formatMoney(updateLiquidacion.monto) }} USD
                  </div>
                </v-card>
              </v-col>
            </v-row>

            <v-divider class="my-4" />
            <v-row dense>
              <v-col cols="12">
                <v-menu
                  ref="menuEmisionLiquidacion"
                  v-model="menuEmisionLiquidacion"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="updateLiquidacion.fechaLiquidacion"
                      label="Fecha de liquidación"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      :rules="[rules.required]"
                      style="border-radius: 10px;"
                      class="mb-2"
                      outlined
                      hide-details
                      dense
                    />
                  </template>
                  <v-date-picker color="black" v-model="updateLiquidacion.fechaLiquidacion" @input="menuEmisionLiquidacion = false" />
                </v-menu>
              </v-col>
            </v-row>
            <!-- Acciones -->
            <v-card-actions>
              <v-btn 
                block
                large
                color="black"
                class="white--text mt-2"
                style="border-radius: 10px; text-transform: none; font-weight: 600;" 
                @click="updatePaymentLiquidacion()"
              >
                Guardar
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
    </v-container>
</template>

<script>
import moment from 'moment';

export default {
  data() {
    return {
      dialogUpdateInvoice: false,
      dialogCreateAdjust: false,
      dialogUpdateAdelanto: false,
      dialogUpdateCobro: false,
      dialogUpdateLiquidacion: false,
      loadingUpdateInvoice: false,
      loadingUpdateAdjust: false,
      loadingUpdateAdelanto: false,
      loadingUpdateCobro: false,
      loadingUpdateLiquidacion: false,
      factura: {},
      updateInvoice: {
        po: '',
        referencia: '',
        monto: 0,
        fechaEmision: '',
        fechaVencimiento: '',
        ajuste: 0,
      },
      updateAdelanto: {
        monto: 0,
        fechaAdelanto: '',
      },
      updateCobro: {
        monto: 0,
        fechaCobro: '',
      },
      updateLiquidacion: {
        monto: 0,
        fechaLiquidacion: '',
      },
      isLoading: false,
      menuEmision: false,
      menuEmisionCobro: false,
      menuEmisionLiquidacion: false,
      menuVencimiento: false,
      rules: {
        required: value => !!value || 'Este campo es requerido.',
      },
    };
  },
  computed: {
    montoSugerido() {
      const pagoDeudor = +((+this.factura.pagosDeudor?.[0]?.amount || 0).toFixed(2));
      const adelanto = +((+this.factura.adelantos?.[0]?.amount_applied || 0).toFixed(2));
      const interesMoratorio = +(
        this.factura.dias_moratorios > 0
          ? (this.factura.monto_total * (this.factura.dias_moratorios / this.factura.dias_credito * (this.factura.tasa_interes / 100))).toFixed(2)
          : "0.00"
      );
      const interes = +(((+this.factura.monto_total || 0) * (this.factura.tasa_interes / 100)).toFixed(2));

      const resultado = pagoDeudor - adelanto - interes - interesMoratorio;

      return +resultado.toFixed(2);
    },
    montoLiquidadoTotal() {
      const liquidado = this.factura.liquidaciones?.reduce((acc, l) => acc + Number(l.amount || 0), 0);
      const compensado = this.factura.compensaciones?.reduce((acc, c) => acc + Number(c.amount_applied || 0), 0);
      return liquidado + compensado;
    },
    diferenciaFinal() {
      const liquidado = this.factura.liquidaciones?.reduce((acc, l) => acc + Number(l.amount || 0), 0);
      return this.montoSugerido - liquidado;
    },
    totalCompensado() {
      return this.factura.compensaciones?.reduce((acc, c) => acc + Number(c.amount_applied || 0), 0);
    }
  },
  methods: {
    async getDetailInvoice() {
      try {
        this.isLoading = true;
        const response = await DB.get(`${URI}/api/v1/en/factoringInvoices/detail/${this.$route.params.invoiceId}`, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        });

        this.isLoading = false;
        this.factura = response.data.invoice;
        this.factura.compensaciones = response.data.compensaciones || [];
        this.factura.statusHistory = response.data.statusHistory || [];
        this.factura.documentos = response.data.documentos || [];
        this.factura.liquidaciones = response.data.liquidaciones || [];
        this.factura.adelantos = response.data.adelantos || [];
        this.factura.pagosDeudor = response.data.pagosDeudor || [];

        // 👉 Calcular días moratorios
        const fechaVencimiento = moment(this.factura.fecha_vencimiento);

        const cobroStatus = this.factura.statusHistory?.find(s => s.status === 'cobrada');

        if (this.factura?.pagosDeudor) {
          const fechaCobro = moment(this.factura.pagosDeudor.reduce((latest, pago) => {
            const pagoDate = moment(pago.date_paid);
            return pagoDate.isAfter(latest) ? pagoDate : latest;
          }, moment(0)));
          const diasMoratorios = fechaCobro.diff(fechaVencimiento, 'days');
          this.factura.dias_moratorios = diasMoratorios > 0 ? diasMoratorios : 0;
        } else {
          this.factura.dias_moratorios = 0;
        }

        this.mixSuccess(response.data.message || 'Factura mostrada correctamente');
        this.dialogValidateInvoice = false;
      } catch (error) {
        if (error.response?.data?.code) {
          this.$router.push("/welcome").catch(() => {});
        }
      } finally {
        this.isLoading = false;
      }
    },
    openUpdateInvoice() {
      this.dialogUpdateInvoice = true;
      this.updateInvoice.po = this.factura.external_invoice_id;
      this.updateInvoice.referencia = this.factura.reference;
      this.updateInvoice.monto = this.factura.monto_total;
      this.updateInvoice.fechaEmision = moment(this.factura.fecha_emision).format("YYYY-MM-DD");
      this.updateInvoice.fechaVencimiento = moment(this.factura.fecha_vencimiento).format("YYYY-MM-DD");
    },
    openCreateAdjust() {
      this.dialogCreateAdjust = true;
      this.updateInvoice.ajuste = this.factura.ajuste || 0;
    },
    openUpdateAdelanto(adelanto) {
      this.dialogUpdateAdelanto = true;
      this.updateAdelanto.id = adelanto.id;
      this.updateAdelanto.monto = adelanto.amount;
      this.updateAdelanto.fechaAdelanto = moment(adelanto.created_at).format("YYYY-MM-DD");
    },
    openUpdateCobro(cobro) {
      this.dialogUpdateCobro = true;
      this.updateCobro.id = cobro.id;
      this.updateCobro.monto = cobro.amount;
      this.updateCobro.fechaCobro = moment(cobro.created_at).format("YYYY-MM-DD");
    },
    openUpdateLiquidacion(liq) {
      this.dialogUpdateLiquidacion = true;
      this.updateLiquidacion.id = liq.id;
      this.updateLiquidacion.monto = liq.amount;
      this.updateLiquidacion.fechaLiquidacion = moment(liq.created_at).format("YYYY-MM-DD");
    },
    formatMoney(value) {
      return new Intl.NumberFormat('en-US', {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value);
    },
    formatDate: function (date) {
      if (this.selectLanguage === "sp") {
        moment.locale("es");
      } else {
        moment.locale("en");
      }
      let newDate = moment(date);
      let formattedDate = newDate.format("MMMM DD, YYYY");
      return formattedDate;
    },
    abrirDocumento(doc) {
      window.open(`${doc.file_url}`, '_blank');
    },
    abrirComprobante(doc) {
      window.open(doc, '_blank');
    },
    saveUpdateInvoice() {
      this.loadingUpdateInvoice = true;
      const payload = {
        invoiceId: this.$route.params.invoiceId,
        external_invoice_id: this.updateInvoice.po,
        reference: this.updateInvoice.referencia,
        monto_total: this.updateInvoice.monto,
        fecha_emision: this.updateInvoice.fechaEmision,
        fecha_vencimiento: this.updateInvoice.fechaVencimiento,
      };

      DB.post(`${URI}/api/v1/en/factoringInvoices/updateInvoice`, payload, {
        headers: {
          Authorization: this.$store.state.sToken
            ? `Bearer ${this.$store.state.sToken}`
            : ""
        }
      })
      .then((response) => {
        this.loadingUpdateInvoice = false;
        this.dialogUpdateInvoice = false;
        this.getDetailInvoice();
        this.mixSuccess(response.data.message);
      }).catch((error) => {
        this.loadingUpdateInvoice = false;
        this.mixError(error.response.data.message, error.response.status);
      });
    },
    addAdjustment() {
      this.loadingAdjustment = true;
      const payload = {
        invoiceId: this.$route.params.invoiceId,
        ajuste: this.updateInvoice.ajuste,
      };

      DB.post(`${URI}/api/v1/en/factoringInvoices/adjustmentInvoice`, payload, {
        headers: {
          Authorization: this.$store.state.sToken
            ? `Bearer ${this.$store.state.sToken}`
            : ""
        }
      })
      .then((response) => {
        this.loadingAdjustment = false;
        this.dialogCreateAdjust = false;
        this.getDetailInvoice();
        this.mixSuccess(response.data.message);
      }).catch((error) => {
        this.loadingAdjustment = false;
        this.mixError(error.response.data.message, error.response.status);
      });
    },
    updatePaymentAdelanto() {
      this.loadingPaymentAdelanto = true;
      const payload = {
        paymentId: this.updateAdelanto.id,
        amount: this.updateAdelanto.monto,
        created_at: this.updateAdelanto.fechaAdelanto,
      };

      DB.post(`${URI}/api/v1/en/paymentsCedente/updatePaymentCedente`, payload, {
        headers: {
          Authorization: this.$store.state.sToken
            ? `Bearer ${this.$store.state.sToken}`
            : ""
        }
      })
      .then((response) => {
        this.loadingPaymentAdelanto = false;
        this.dialogUpdateAdelanto = false;
        this.getDetailInvoice();
        this.mixSuccess(response.data.message);
      }).catch((error) => {
        this.loadingPaymentAdelanto = false;
        this.mixError(error.response.data.message, error.response.status);
      });
    },
    updatePaymentCobro() {
      this.loadingPaymentCobro = true;
      const payload = {
        paymentId: this.updateCobro.id,
        amount: this.updateCobro.monto,
        created_at: this.updateCobro.fechaCobro,
      };

      DB.post(`${URI}/api/v1/en/paymentsDebtor/updatePaymentDeudor`, payload, {
        headers: {
          Authorization: this.$store.state.sToken
            ? `Bearer ${this.$store.state.sToken}`
            : ""
        }
      })
      .then((response) => {
        this.loadingPaymentCobro = false;
        this.dialogUpdateCobro = false;
        this.getDetailInvoice();
        this.mixSuccess(response.data.message);
      }).catch((error) => {
        this.loadingPaymentCobro = false;
        this.mixError(error.response.data.message, error.response.status);
      });
    },
    updatePaymentLiquidacion() {
      this.loadingPaymentLiquidacion = true;
      const payload = {
        paymentId: this.updateLiquidacion.id,
        amount: this.updateLiquidacion.monto,
        created_at: this.updateLiquidacion.fechaLiquidacion,
      };

      DB.post(`${URI}/api/v1/en/paymentsCedente/updatePaymentCedente`, payload, {
        headers: {
          Authorization: this.$store.state.sToken
            ? `Bearer ${this.$store.state.sToken}`
            : ""
        }
      })
      .then((response) => {
        this.loadingPaymentLiquidacion = false;
        this.dialogUpdateLiquidacion = false;
        this.getDetailInvoice();
        this.mixSuccess(response.data.message);
      }).catch((error) => {
        this.loadingPaymentLiquidacion = false;
        this.mixError(error.response.data.message, error.response.status);
      });
    },
  },
  beforeMount() {
    this.getDetailInvoice();
  }
};
</script>
